import { faMeta } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@feathr/components';

function MetaConnectButton(): JSX.Element {
  const { t } = useTranslation();

  return (
    <Button
      name={'connect-meta-button'}
      prefix={<FontAwesomeIcon icon={faMeta} />}
      type={'primary'}
    >
      {t('Connect Meta Business Manager')}
    </Button>
  );
}

export default MetaConnectButton;
